import React, { Component, PropTypes } from 'react';
import Row from 'muicss/lib/react/row';
import Col from 'muicss/lib/react/col';
import Button from 'muicss/lib/react/button';
import { Link } from 'react-router/es';

export default class ChangeAccountItems extends Component {
  static propTypes = {
    customerNum: PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.string,
    ]),
    customerName: PropTypes.string,
    customerAddress: PropTypes.string,
    onItemClick: PropTypes.func,
    skey: PropTypes.string,
  };
  constructor() {
    super();
    this.onClick = this.onClick.bind(this);
  }

  onClick() {
    const { customerName, customerNum, customerAddress, onItemClick } = this.props;
    onItemClick(customerName, customerNum, customerAddress);
  }

  render() {
    const { customerName, customerNum, skey } = this.props;

    const customerNameKeyIndex = customerName.toLowerCase().indexOf(skey.toLowerCase());
    let boldPrevCustomerName = customerName.substring(0, customerNameKeyIndex);
    let boldCustomerName = customerName.substring(customerNameKeyIndex, customerNameKeyIndex + skey.length);
    let boldNextCustomerName = customerName.substring(customerNameKeyIndex + skey.length);
    if (customerNameKeyIndex < 0) {
      boldPrevCustomerName = null;
      boldCustomerName = null;
      boldNextCustomerName = customerName;
    }

    const customerNumKeyIndex = customerNum.toLowerCase().indexOf(skey.toLowerCase());
    let boldPrevCustomerNum = customerNum.substring(0, customerNumKeyIndex);
    let boldCustomerNum = customerNum.substring(customerNumKeyIndex, customerNumKeyIndex + skey.length);
    let boldNextCustomerNum = customerNum.substring(customerNumKeyIndex + skey.length);
    if (customerNumKeyIndex < 0) {
      boldPrevCustomerNum = null;
      boldCustomerNum = null;
      boldNextCustomerNum = customerNum;
    }

    return (
      <div className='pointer search-item' onClick = { this.onClick }>
        <div>
          <Link>{boldPrevCustomerName}<b>{boldCustomerName}</b>{boldNextCustomerName}</Link>
        </div>
        <div>
          <Link>Account #: {boldPrevCustomerNum}<b>{boldCustomerNum}</b>{boldNextCustomerNum}</Link>
        </div>
      </div>
    );
  }
}
